import { render } from "./Guide.vue?vue&type=template&id=55d50df3&scoped=true"
import script from "./Guide.vue?vue&type=script&lang=js"
export * from "./Guide.vue?vue&type=script&lang=js"

import "./Guide.vue?vue&type=style&index=0&id=55d50df3&scoped=true&lang=css"

import exportComponent from "/Users/ginea/Desktop/template_demo/vuejs-tailwindcss-portfolio-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d50df3"]])

export default __exports__